import React, {Component} from 'react';
import './CreateTimeCampaign.css';
import CampaignsPreviewPhone from "../../CampaignsPreviewPhone/CampaignsPreviewPhone";

const CreateTimeCampaign = (props) => {
    const {handleCampaignData, companyData} = props;
    const values = {};
    return (
        <div>
            CreateTimeCampaign
            <CampaignsPreviewPhone campaignData={values} companyData={companyData}/>
        </div>
    )
};

export default CreateTimeCampaign;
